module.exports = new __parcel__URL__("missions_text.b723eab3.png").toString();